import CalendarScheduleSlotModel from "../../../models/CalendarScheduleSlotModel";
import { useState } from "react";
import WeeklySessionInfo from "../../sessions/WeeklySessionInfo";
import CompactCanceledSlot from "./CompactCanceledSlot";
import ExtendedCanceledSlot from "./ExtendedCanceledSlot";

export default function CanceledSlot(props: {
  slot: CalendarScheduleSlotModel;
  compact: boolean;
  onClick: (slot: CalendarScheduleSlotModel) => void;
}) {
  const [open, setOpen] = useState<boolean>(false);

  if (props.compact) {
    return (
      <>
        <CompactCanceledSlot setOpen={() => setOpen(true)} {...props} />
        {!!props?.slot && (
          <>
            <WeeklySessionInfo
              session={props?.slot}
              onClose={() => setOpen(false)}
              cancel={false}
              open={open}
              setIsOpen={() => {
                setOpen(false);
              }}
            />
          </>
        )}
      </>
    );
  }

  return <ExtendedCanceledSlot {...props} />;
}
